/** @modules Components */
import { FC } from 'react'
import {
  GlobeAmericasIcon,
  HeartIcon,
  BeakerIcon,
  ChartBarIcon,
  ChevronRightIcon
} from '@heroicons/react/24/outline'

export const OurPartners: FC = () => {
  return (
    <main className="min-h-screen bg-[#EDE6DE] px-4 py-12 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-serif text-[#3C2416] mb-6">
          Our Partners
        </h1>

        <div className="prose prose-lg max-w-none mb-12">
          <p className="text-[#3C2416]">
            These organizations are ones that we have partnered with in order to
            make the impact of your donations and support as large as possible.
            The work being done by the organizations listed here is saving lives
            and improving patient outcomes all over the world.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* SCAPN */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <GlobeAmericasIcon
                  className="h-8 w-8 text-[#A6410A]"
                  data-testid="partner-icon"
                />
                <h3 className="text-2xl font-serif">
                  <a
                    href="https://www.scapn.org/"
                    className="text-[#3C2416] hover:text-[#A6410A] transition-colors inline-flex items-center gap-2 group"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sickle Cell Adult Provider Network
                    <ChevronRightIcon className="h-5 w-5 transform group-hover:translate-x-1 transition-transform" />
                  </a>
                </h3>
              </div>
              <p className="text-[#3C2416]">
                The Sickle Cell Adult Provider Network (SCAPN) was established
                in 2002 with a mission to establish a network for healthcare
                providers who serve adults with sickle cell disease. This was
                the first and remains the only national organization that offers
                a home for healthcare professionals from multiple disciplines
                who focus on adult-oriented research, clinical care, provides
                education/training, mentorship, and advocacy.
              </p>
            </div>
          </div>

          {/* SCDAA */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <HeartIcon
                  className="h-8 w-8 text-[#A6410A]"
                  data-testid="partner-icon"
                />
                <h3 className="text-2xl font-serif">
                  <a
                    href="https://www.sicklecelldisease.org/"
                    className="text-[#3C2416] hover:text-[#A6410A] transition-colors inline-flex items-center gap-2 group"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sickle Cell Disease Association of America
                    <ChevronRightIcon className="h-5 w-5 transform group-hover:translate-x-1 transition-transform" />
                  </a>
                </h3>
              </div>
              <p className="text-[#3C2416]">
                The Sickle Cell Disease Association of America&apos;s mission
                statement is: to advocate for people affected by sickle cell
                conditions and empower community-based organizations to maximize
                quality of life and raise public consciousness while advancing
                the search for a universal cure.
              </p>
            </div>
          </div>

          {/* ASH */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <BeakerIcon
                  className="h-8 w-8 text-[#A6410A]"
                  data-testid="partner-icon"
                />
                <h3 className="text-2xl font-serif">
                  <a
                    href="https://www.hematology.org/"
                    className="text-[#3C2416] hover:text-[#A6410A] transition-colors inline-flex items-center gap-2 group"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    American Society of Hematology
                    <ChevronRightIcon className="h-5 w-5 transform group-hover:translate-x-1 transition-transform" />
                  </a>
                </h3>
              </div>
              <p className="text-[#3C2416]">
                The Society&apos;s mission is to further the understanding,
                diagnosis, treatment, and prevention of disorders affecting the
                blood, bone marrow, and the immunologic, hemostatic and vascular
                systems, by promoting research, clinical care, education,
                training, and advocacy in hematology.
              </p>
            </div>
          </div>

          {/* CDC SCDC */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <ChartBarIcon
                  className="h-8 w-8 text-[#A6410A]"
                  data-testid="partner-icon"
                />
                <h3 className="text-2xl font-serif">
                  <a
                    href="https://www.cdc.gov/ncbddd/hemoglobinopathies/scdc.html"
                    className="text-[#3C2416] hover:text-[#A6410A] transition-colors inline-flex items-center gap-2 group"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sickle Cell Data Collection Program
                    <ChevronRightIcon className="h-5 w-5 transform group-hover:translate-x-1 transition-transform" />
                  </a>
                </h3>
              </div>
              <p className="text-[#3C2416]">
                The Center For Disease Control and Prevention&apos;s Sickle Cell
                Data Collection (SCDC) program collects health information about
                people with sickle cell disease (SCD) to study long-term trends
                in diagnosis, treatment, and healthcare access for people with
                SCD in the United States. The program helps to inform policy and
                healthcare standards that improve and extend the lives of people
                with SCD.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default OurPartners
